import type {
  SubscriptionApi,
  SubscriptionApiQuery,
  SubscribeApiQuery,
  CancelSubscriptionApiQuery,
  UpdateSubscriptionStatusApiQuery,
} from "@/Modules/Models/Api/Subscription";

import { SubscriptionApiStatus } from "@/Modules/Models/Api/Subscription";

import { get2, post2, patch2, remove2 } from "./utils/FunctionalTherapyApi";

export function getSubscription(customerUuid: string): Promise<SubscriptionApi> {
  return get2<SubscriptionApiQuery, SubscriptionApi>("/v1.0/subscriptions", {
    customer_uuid: customerUuid,
  });
}

export function subscribeToPlan(subscribeApiQuery: SubscribeApiQuery): Promise<SubscriptionApi> {
  return post2<SubscribeApiQuery, SubscriptionApi>("/v1.0/subscriptions", subscribeApiQuery);
}

export function subscribeToB2bPlan(): Promise<SubscriptionApi> {
  return post2<void, SubscriptionApi>("/v1.0/subscriptions/me/continue");
}

export function cancelSubscription(cancelSubscriptionApiQuery: CancelSubscriptionApiQuery): Promise<void> {
  return remove2<CancelSubscriptionApiQuery, void>("/v2.0/subscriptions", cancelSubscriptionApiQuery);
}

export function updateSubscriptionStatus(subscriptionUuid: string): Promise<SubscriptionApi> {
  return patch2<UpdateSubscriptionStatusApiQuery, SubscriptionApi>(
    `/v1.0/subscriptions/${subscriptionUuid}`,
    {
      status: SubscriptionApiStatus.ACTIVE,
    }
  );
}
